/** ดาบค้อนช่างใหญ่ (lane C3 skeleton): temple gold + fire, vajra rays. Built from swordKit via families/swordArtGen.ts; polish later. */
import { makeArt } from '../families/swordArtGen';

export const DEMON_FX: ReturnType<typeof makeArt> = makeArt('founder-sabre', { a: 'gold', b: 'fire', motif: 'rays' }, [
  ['fm-subdue', 'slash'],
  ['fm-heavy', 'break'],
  ['fm-cross', 'lock'],
  ['fm-wheel', 'sweep', 5],
  ['fm-stride', 'thrust', 56],
  ['fm-bell', 'buff'],
  ['fm-zen', 'heal'],
  ['fm-vanquish', 'power', 3.5],
]);
